import { render } from "./ProductListSelect.vue?vue&type=template&id=35e91f68&scoped=true"
import script from "./ProductListSelect.vue?vue&type=script&lang=js"
export * from "./ProductListSelect.vue?vue&type=script&lang=js"

import "./ProductListSelect.vue?vue&type=style&index=0&id=35e91f68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e91f68"]])

export default __exports__